import { useParams } from 'react-router-dom';

import { useTemplateDetailsQuery } from '../queries';
import { Page } from './page';

export function DuplicatePage() {
  const { id } = useParams();
  const template = useTemplateDetailsQuery({ id });

  return <Page template={template} />;
}
